import { Reveal, MaskedLine } from "@/components/Reveal";

const SHOTS = [
  { src: "/images/rebel-1.webp", alt: "Rebel wearing the SHUTUP tee at the beach", rot: "-rotate-1" },
  { src: "/images/rebel-2.jpg", alt: "Rebel in the SHUTUP tee on a graffiti street", rot: "rotate-2" },
  { src: "/images/rebel-3.jpg", alt: "Rebel selfie in the SHUTUP tee", rot: "-rotate-2" },
  { src: "/images/rebel-4.webp", alt: "Rebel showing the back artwork against a tree", rot: "rotate-1" },
  { src: "/images/rebel-5.webp", alt: "Rebel at the fairground in the SHUTUP tee", rot: "-rotate-1" },
];

export { SHOTS };

export default function People() {
  return (
    <section data-testid="people-section" className="bg-ink text-paper py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-10">
        <Reveal>
          <p className="font-sans text-turq text-xs font-semibold tracking-[0.35em] mb-8">04 — THE PEOPLE</p>
        </Reveal>
        <h2 className="font-display leading-[0.9]">
          <MaskedLine inView className="text-[clamp(2.8rem,9vw,8rem)]">
            WEAR YOUR <span className="text-pink">VOICE.</span>
          </MaskedLine>
          <MaskedLine inView delay={0.1} className="text-[clamp(1.6rem,4.5vw,3.5rem)] text-paper/60">
            HOWEVER YOU WANT.
          </MaskedLine>
        </h2>
        <Reveal delay={0.2}>
          <p className="font-hand text-acid text-2xl mt-6 rotate-1">look at the rebellions →</p>
        </Reveal>
      </div>

      <div className="mt-12 flex gap-5 sm:gap-8 overflow-x-auto no-scrollbar snap-x snap-mandatory px-5 sm:px-10 pb-6" data-testid="people-gallery" data-cursor="scroll">
        {SHOTS.map((s, i) => (
          <figure key={i} data-testid={`rebel-${i + 1}`} className={`snap-center shrink-0 ${s.rot} transition-transform duration-500 hover:rotate-0 hover:scale-[1.02]`}>
            <img
              loading="lazy"
              decoding="async" src={s.src} alt={s.alt} className="h-[55vh] sm:h-[68vh] w-auto object-cover border border-white/10" />
            <figcaption className="font-sans text-paper/40 text-[10px] tracking-[0.3em] mt-3">
              THE REBELLION — {String(i + 1).padStart(2, "0")}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
